import { useState, useEffect, useCallback } from "react";
import { FileService } from "../../../services/SubmissionService";
import * as APIModels from "../../../models";
import pdfIcon from "../../../assets/images/file-icons/pdf.svg";
import zipIcon from "../../../assets/images/file-icons/zip.svg";
import { useDropzone } from "react-dropzone";
import { formatBytes } from "../../../helpers/utility";
import { Endpoints } from "../../../helpers/Endpoints";

type NameValueOptionType = { label: string; value: number };

export default function AttachFiles({
    callback,
}: {
    callback: (exhibits: APIModels.Exhibits) => void;
}) {
    const options: NameValueOptionType[] = [];

    const f: APIModels.FileInfo[] = [];
    const [files, setFiles] = useState(f);

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file: any) => {
            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: file,
                filename: "uploads/" + file.name,
            }).then(
                (resp) => {
                    console.log(resp);
                    resp.text().then((text) => console.log(text));
                },
                (error) => {
                    console.log(error);
                }
            );
        });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        maxSize: 35000000,
        accept: "application/pdf",
    });

    const onFileUpload = (event: React.FormEvent) => {
        event.preventDefault();
        console.log("on upload");
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }

        for (let i = 0; i < input.files.length; i++) {
            const f = input.files[i];
            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: f,
                filename: "uploads/" + f.name,
            }).then(
                (resp) => {
                    console.log(resp);
                    input.value = "";
                },
                (error) => {
                    console.log(error);
                    input.value = "";
                }
            );
        }
    };

    useEffect(() => {
        callback({
            filenames: files.map((v, i) => v.filename ?? ""),
        });
    }, [files]);

    const onDelete = (file: APIModels.FileInfo) => {
        if (file.filename) {
            FileService.delete({ filename: file.filename }).then(
                (resp) => {
                    console.log(resp);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    return (
        <div className="card-body">
            <h4 className="header-title">File Upload</h4>
            <p className="sub-header">
                Drop additional files in the area below to add them to the
                submission.
            </p>
            <div className="row">
                <div className="col-sm-12">
                    <div {...getRootProps({ className: "dropzone card-body" })}>
                        <div className="fileupload btn btn-success waves-effect waves-light mb-3">
                            <span>
                                <i className="mdi mdi-cloud-upload me-1"></i>{" "}
                                Upload Files
                            </span>
                            <input
                                {...getInputProps()}
                                onChange={onFileUpload}
                            />
                        </div>
                        <div>* 35 MB Maximum Upload Size</div>
                        <div
                            className="table-responsive"
                            style={{ overflow: "visible" }}
                        >
                            <table
                                className="table table-centered  table-nowrap mb-0"
                                style={{ zIndex: 0 }}
                            >
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col">File Name</th>
                                        <th scope="col">Date Modified</th>
                                        <th scope="col">Size</th>
                                        <th
                                            scope="col"
                                            className="text-center"
                                            style={{ width: 125 }}
                                        >
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {files.map((file, i) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <img
                                                        src={
                                                            file.filename &&
                                                            file.filename
                                                                .toLowerCase()
                                                                .endsWith(
                                                                    ".pdf"
                                                                )
                                                                ? pdfIcon
                                                                : zipIcon
                                                        }
                                                        height="30"
                                                        alt="icon"
                                                        className="me-2"
                                                    />
                                                    <a
                                                        href="javascript:void(0);"
                                                        className="text-dark"
                                                    >
                                                        {file.filename}
                                                    </a>
                                                </td>
                                                <td className="font-13">
                                                    {file.lastUpdatedDateTime}
                                                </td>
                                                <td>
                                                    {formatBytes(
                                                        file.size ?? 0
                                                    )}
                                                </td>
                                                <td>
                                                    <ul
                                                        className="list-inline table-action m-0"
                                                        style={{
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        <li className="list-inline-item">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="action-icon px-1"
                                                                onClick={() =>
                                                                    onDelete(
                                                                        file
                                                                    )
                                                                }
                                                            >
                                                                {" "}
                                                                <i className="mdi mdi-delete"></i>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
